/* eslint-disable no-unused-expressions */
import React from "react";
import Secure from "assets/img/secure.svg"

const IconLock = props => (
  <img src={Secure}/>
);

export default IconLock;
